import Route from '@ember/routing/route';

export default class ThanksRoute extends Route {}
